module.exports = __webpack_public_path__ + "img/hand.24d4bfa8.svg";